<template>
  <div class="help-container">
    <div class="interface-details w">
      <div class="left">
        <div class="interface-list">
          <div
            class="interface-list-item"
            :class="showListPanel && showListPanelIndex === index ? 'auto' : ''"
            v-for="(item, index) in interfaceList"
            :key="index"
          >
            <div class="interface-list-item-title" @click="toggleList(index)">
              <div class="interface-list-item-title-title line1">
                {{ item.title }}
              </div>
              <img src="../assets/arrow.png" class="arrow" alt="" />
            </div>
            <div class="inner-section-list-panel">
              <div
                class="inner-section-list-panel-item"
                :class="listPanelIndex === idx ? 'active' : ''"
                v-for="(itm, idx) in item.list"
                :key="idx"
                @click="clickPanel(idx)"
              >
                <a>{{ itm.title }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <noticesOne
          v-if="showListPanelIndex == 0 && listPanelIndex == 0"
        ></noticesOne>
        <noticesTwo
          v-if="showListPanelIndex == 0 && listPanelIndex == 1"
        ></noticesTwo>
        <noticesThree
          v-if="showListPanelIndex == 0 && listPanelIndex == 2"
        ></noticesThree>
        <noticesFour
          v-if="showListPanelIndex == 0 && listPanelIndex == 3"
        ></noticesFour>
      </div>
    </div>
  </div>
</template>

<script>
import noticesOne from "./notices/1.vue";
import noticesTwo from "./notices/2.vue";
import noticesThree from "./notices/3.vue";
import noticesFour from "./notices/4.vue";
export default {
  name: "help",
  components: { noticesOne, noticesTwo, noticesThree, noticesFour },
  data() {
    return {
      showListPanel: true,
      showListPanelIndex: 0,
      listPanelIndex: 0,
      interfaceList: [
        {
          title: "常见问题",
          list: [
            {
              title: "注册与登录",
              content: "注册与登录",
            },
            {
              title: "推广效果",
              content: "推广效果",
            },
            {
              title: "结算/提现",
              content: "结算/提现",
            },
            {
              title: "发票抬头信息",
              content: "发票抬头信息",
            },
          ],
        },
      ],
    };
  },
  created() {},
  watch: {},
  methods: {
    toggleList(index) {
      this.showListPanel = !this.showListPanel;
      this.showListPanelIndex = index;
    },
    clickPanel(index) {
      this.listPanelIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.help-container {
  min-height: calc(100vh - 60px - 360px);
  background-color: #f5f5f5;

  .interface-details {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    column-gap: 16px;
    min-height: calc(100vh - 60px - 360px);
    box-sizing: border-box;

    .left {
      width: 256px;
      background-color: #fff;

      .interface-list {
        padding: 10px 0;

        .interface-list-item {
          position: relative;
          font-weight: 500;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.6);
          height: 48px;
          overflow: hidden;

          .interface-list-item-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 48px;
            cursor: pointer;
            padding-left: 16px;
            padding-right: 16px;
            position: relative;

            // .interface-list-item-title-title { }

            .arrow {
              width: 16px;
              height: 16px;
              transition: all 0.3s;
            }
          }

          .inner-section-list-panel {
            height: auto;

            .inner-section-list-panel-item {
              margin-top: 6px;
              height: 48px;
              display: flex;
              align-items: center;
              cursor: pointer;
              font-weight: 500;

              &:last-child {
                margin-top: 0;
              }

              &:hover {
                background-color: #ecf2fe;
              }

              a {
                display: flex;
                align-items: center;

                width: 100%;
                height: 100%;
                padding-left: 40px;
              }
            }

            .active {
              background-color: #ecf2fe;
            }
          }
        }

        .auto {
          height: auto;
          overflow-y: auto;

          .interface-list-item-title {
            &::before {
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              content: "";
              width: 2px;
              height: 14px;
              background-color: #4080ff;
            }

            .arrow {
              transform: rotate(180deg);
            }
          }
        }
      }
    }

    .right {
      padding: 16px;
      flex: 1;
      background-color: #fff;
    }
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 768px) and (max-width: 991px) {
}

@media (max-width: 767px) {
  .help-container {
    .interface-details {
      .left {
        display: none;
      }
    }
  }
}
</style>
